export enum OverviewType {

    MyTrades = "trades",
    MyWatchlist = "watchlist"
}
